import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { sideGutterWidth } from '../../../styles/constants';
import { primaryFontFamily } from '../../../styles/fonts';
import { minDeviceWidth } from '../../../styles/responsive';

import { ReactComponent as errorSvgIcon } from './error.svg';

export type ContainerProps = {
  size?: 'default' | 'large';
};

function sizeBasedStyle({ size = 'default' }: ContainerProps) {
  if (size === 'large') {
    return css`
      padding: 16px 24px;
    `;
  }
  return css`
    padding: 8px 16px;
  `;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-bottom: 16px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.default.colors.Feedback.Error};
  box-sizing: border-box;

  background-color: ${({ theme }) =>
    theme.default.colors.Feedback.Variations.Error.Error0};
  color: ${({ theme }) => theme.default.colors.Feedback.Error};

  font-style: normal;
  font-weight: normal;
  line-height: 19px;
  font-size: 14px;
  line-height: 20px;
  ${primaryFontFamily}

  ${sizeBasedStyle}
`;

export const Icon = styled(errorSvgIcon)`
  margin-right: 24px;
`;

export const ErrorWrapper = styled.div`
  margin: 0 ${sideGutterWidth.mobile}px;

  @media ${minDeviceWidth('mobile-landscape')} {
    margin: 0 ${sideGutterWidth['mobile-landscape']}px;
  }

  @media ${minDeviceWidth('tablet')} {
    margin: 0 ${sideGutterWidth.tablet}px;
  }

  @media ${minDeviceWidth('desktop')} {
    margin: 0;
  }
`;
